import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import EFVideo from '@/components/UI/EFVideo';

export default function home4() {
    const { useLang, useEffect, useRef, useState, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['cn', 'za']);

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const [enter, setEnter] = useState(false);
    const videoRef = useRef();
    useEffect(() => {
        // mm100_home2进入视窗渲染video
        const videoEl = document.querySelector(`.home4`) as HTMLElement;
        const scene = new ScrollMagic.Scene({
            triggerElement: videoEl,
            triggerHook: 1,
            offset: 0,
        });
        scene.on('enter', () => {
            setEnter(true);
        });
        scene.addTo(controller);
    }, []);

    useEffect(() => {
        if (videoRef) {
            const videoBoxEl = document.querySelector(`.home4 .videoBox`) as HTMLElement;
            // 视频的一半区域进入视窗后开始播放
            const scene1 = new ScrollMagic.Scene({
                triggerElement: `.home4 .videoBox`,
                triggerHook: 1,
                offset: videoBoxEl?.offsetHeight / 2,
            });
            scene1.on('enter', () => {
                videoRef?.current?.play();
            });
            controller.addScene(scene1);
        }
    }, [videoRef]);

    return (
        <div className={`home4 ${css.home4}`}>
            <div className="textBox">
                <p className="guide">{t('presale.product.home3_2_text1')}</p>
                <p className="title">{t('presale.product.home3_2_text2')}</p>
                <p className="text">{t('presale.product.home3_2_text3')}</p>
            </div>
            <div className="videoBox">
                {enter && (
                    <EFVideo
                        ref={videoRef}
                        className="mm100_home4_video_h5"
                        sources={[`/video/mm100m/controls_h5_${imgLocal}.webm`, `/video/mm100/controls_h5_${imgLocal}.mp4`]}
                        width={'100%'}
                        height={'100%'}
                        autoPlay={false}
                    />
                )}
            </div>
        </div>
    );
}
